import { useEffect } from 'react';
import { googlePalService } from 'react-native-google-pal';
import { useRecoilState } from 'recoil';

import { liveVideoPlayerState } from '@store';

export const useGooglePalUpdate = () => {
  const [liveState] = useRecoilState(liveVideoPlayerState);

  useEffect(() => {
    if (liveState.currentLiveVideoStream && !liveState.stopped) {
      googlePalService.sendPlaybackStart();
    } else if (liveState.stopped) {
      googlePalService.sendPlaybackEnd();
    }
  }, [liveState.currentLiveVideoStream, liveState.stopped]);
};
